import type { ReactNode } from 'react';
import { clsx } from 'clsx';
import type { PropsWithClassName } from 'types/react-props';
import { formatMillisecondsToMinutes } from 'utils/time';
import { Icon } from '../Icon';
import styles from './Button.module.scss';

type Variants = 'rtlPlus' | 'video' | 'readMore';

const Button = ({
  variant,
  videoDuration,
  className,
  children,
  onClick,
}: PropsWithClassName<{
  variant?: Variants;
  videoDuration?: number;
  children?: ReactNode;
  onClick?: () => void;
}>) => {
  const DynamicTag = onClick ? 'button' : 'div';

  let content;

  switch (variant) {
    case 'rtlPlus':
      content = (
        <>
          <Icon className={styles.iconPlay} name="play" size={20} />
          <span>
            Jetzt <strong>bei RTL+</strong> streamen
          </span>
          <Icon className={styles.iconExternalLink} name="externalLink" size={16} />
        </>
      );
      break;
    case 'video':
      content = (
        <>
          <Icon className={styles.iconPlay} name="play" size={20} />
          <span>
            Video {!!videoDuration && `[ ${formatMillisecondsToMinutes(videoDuration, '', false)} ]`} • Jetzt ansehen
          </span>
        </>
      );
      break;
    default:
      content = children;
  }

  return (
    <DynamicTag
      onClick={onClick}
      className={clsx(className, styles.button, {
        [styles.rtlPlus]: variant === 'rtlPlus',
        [styles.readMore]: variant === 'readMore',
      })}
      data-testid="button-component"
    >
      {content}
    </DynamicTag>
  );
};

export default Button;
